import type { CSSProperties, ReactNode } from "react";

import { styled } from "simplydo/react/styled";

import { NAV_BAR_HEIGHT, Sticky } from "components/lib/UI";

/** Height of the toolbar on computer, used to offset sticky content below it. */
export const ENTITY_TOOLBAR_HEIGHT = 56;

const ToolbarBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  min-height: ${({ theme }) =>
    theme.sizes.isComputer ? ENTITY_TOOLBAR_HEIGHT : 48}px;
  padding: ${({ theme }) =>
    theme.sizes.isComputer ? "10px 20px" : "8px 12px"};
  background: #ffffff;
  border-bottom: 1px solid #eceef2;
  width: 100%;
  z-index: 90;

  > div {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    min-width: 0;
  }
`;

type EntityToolbarProps = {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
  sticky?: boolean;
  stickyTop?: number;
};

const EntityToolbar = ({
  children,
  style,
  className,
  sticky = true,
  stickyTop = NAV_BAR_HEIGHT,
}: EntityToolbarProps) => {
  const bar = (
    <ToolbarBar style={style} className={className}>
      {children}
    </ToolbarBar>
  );

  if (!sticky) return bar;

  return (
    <Sticky top={stickyTop} style={{ zIndex: (style?.zIndex as number) ?? 90 }}>
      {bar}
    </Sticky>
  );
};

export default EntityToolbar;
